<form #form="ngForm">
    <mat-form-field>
        <mat-label appRemoveAriaOwns>{{ 'reporting.reports.trainingReport.byTrainingPrograms' | translate }}</mat-label>
        <mat-select multiple [formControl]="programsFormControl">
            <mat-option
                (onSelectionChange)="onProgramSelect($event, option)"
                *ngFor="let option of options"
                [value]="option"
                >{{ option.label | translate }}</mat-option
            >
        </mat-select>
    </mat-form-field>
    <div class="filter-input">
        <mat-checkbox (change)="showTerminated = $event.checked">
            <span class="text-color">{{ 'reporting.reports.trainingReport.showTerminatedEmployees' | translate }}</span>
        </mat-checkbox>
    </div>
    <div class="filter-input">
        <mat-checkbox (change)="showHistory = $event.checked">
            <span class="text-color">{{ 'reporting.reports.trainingReport.showHistoricalRecords' | translate }}</span>
        </mat-checkbox>
    </div>
</form>
